export const TOUR_ASK_FALLBACK = "Couldn't reach the guide. Use Next or try again.";

export type TourAskPayload = {
  question: string;
  featureId: string;
  stepId: string;
  stepTitle: string;
  stepBody: string;
};

export async function askTourStep(payload: TourAskPayload): Promise<string> {
  const baseUrl = process.env.REACT_APP_CHATBOT_API_URL;
  if (!baseUrl) {
    return TOUR_ASK_FALLBACK;
  }

  const response = await fetch(`${baseUrl}/tour-ask`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error('Tour ask network error');
  }

  const data = (await response.json()) as { message?: string };
  if (!data.message?.trim()) {
    return TOUR_ASK_FALLBACK;
  }

  return data.message.trim();
}
